import _ from '../../core/utils'
import mapboxgl from 'mapbox-gl'
mapboxgl.accessToken = 'pk.eyJ1IjoiYWRyaWFhbG9zIiwiYSI6ImNrNXoybGpqdTBweGszbG5qNmEwNzJ1dzAifQ.6mtLHsiBciOXdPVRMY3fuQ'
import axios from 'axios'
import qs from 'qs'
import MAP_CASE_POSITION_CONFIG from "./config"


class MapCasePositionClass {
    constructor() {
        this.DOM = {
            el: MAP_CASE_POSITION_CONFIG.el,
            map: null,
            inputLatitude: null,
            inputLongitude: null,
            inputCountry: null,
            save: null,
            country: null
        }
        
        this.latitude = Number
        this.longitude = Number
        this.ico = String
        this.mapbox = null
        this.marker = null
        this.country = null

        this.bounce = false
        this.DOM.el ? this.init() : null
    }

    // INIT
    init() {
        this._mapSet()
        this._mapRender()
        this._controlsNavigation()
        this._buttonEditBounce()
    }

    // MAP: set
    _mapSet() {
        // Map DOM
        this.DOM.map = _.select( '.map', this.DOM.el )
        this.DOM.country = _.select( '.map__country .country' )

        // Map params
        this.latitude = parseFloat( this.DOM.map.getAttribute( 'data-latitude' ) )
        this.longitude = parseFloat( this.DOM.map.getAttribute( 'data-longitude' ) )
        this.ico = this.DOM.map.getAttribute( 'data-marker-ico' )
        this.country = this.DOM.map.getAttribute( 'data-country' ) === '' ? 'Not found' : this.DOM.map.getAttribute( 'data-country' ) 

        // Map form params
        this.DOM.inputLatitude = _.select( '.fl__modal--map input[name="case_latitude"]' )
        this.DOM.inputLongitude = _.select( '.fl__modal--map input[name="case_longitude"]' )
        this.DOM.inputCountry = _.select( '.fl__modal--map input[name="case_country"]' )

        // Map save
        this.DOM.save = _.select( 'button.form--case-map-position' )
    }
    // MAP: render
    _mapRender() {
        this.mapbox = new mapboxgl.Map({
            container: this.DOM.map,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [ this.longitude, this.latitude ],
            zoom: 2 
        });
        
        this.mapbox.on( 'load', () => {
            this._markerAdd()
            this._markerDraggable()
            this._countryGet()
        })
        
    }

    // CONTROLS
    // CONTROLS: navigation
    _controlsNavigation() {
        this.mapbox.addControl( new mapboxgl.NavigationControl() )
    }

    // MARKER
    // MARKER: add
    _markerAdd() {
        const marker = document.createElement( 'div' )
        marker.className = 'fl__marker'
        marker.innerHTML = `<span style="background-image:url(${this.ico})"></span>`

        this.marker = new mapboxgl.Marker( marker, {
        }).setLngLat( [ this.longitude, this.latitude ] ).addTo( this.mapbox )
    }
    // MARKER: draggable
    _markerDraggable() {
        this.marker.setDraggable( true )
        this._markerOnDragEnd()
    }
    // MARKER: on drag end
    _markerOnDragEnd() {
        this.marker.on( 'dragend', () => {
            const lngLat = this.marker.getLngLat()
            this.DOM.inputLatitude.value = lngLat.lat
            this.DOM.inputLongitude.value = lngLat.lng
            console.log( lngLat.lat )
            console.log( this.DOM.inputLatitude.value)
            console.log( this.DOM.inputLongitude.value)

            axios.get( `https://api.mapbox.com/geocoding/v5/mapbox.places/${lngLat.lng},${lngLat.lat}.json?access_token=${mapboxgl.accessToken}` )
            .then( ( response ) => {
                this._markerGetCountry( response )
            })
            .catch( ( error ) => {
                if (error.response) {
                    // Request made and server responded
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                  } else if (error.request) {
                    // The request was made but no response was received
                    
                  } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                  }
            })
        })
    }
    // MARKER: get country
    _markerGetCountry( response ) {
        let features = response.data.features
        let countryFeature = features.filter( ( f ) => f.place_type[0] === 'country' )
        console.log( features )
        if ( countryFeature.length > 0 ) {  
            this.country = countryFeature[0].text
        } else {
            this.country = 'Not found'
        }

        this._countryGet()
    }

    // COUNTRY
    // COUNTRY: get
    _countryGet() {
        this.DOM.country.innerHTML = this.country
        this.DOM.inputCountry.value = this.country === 'Not found' ? '0' : this.country
    }

    _buttonEditBounce() {
        let button =  _.select( '.fl__edit-status--case-position' )
        if ( this.latitude === 54.284581281962 && this.longitude === 19.973038331372 ) {
           _.addClass( button, 'fl__edit--bounce' )
        } else {
            _.removeClass( button, 'fl__edit--bounce' )
        }
    }
    
}

const MAP_CASE_POSITION = new MapCasePositionClass()
export default MAP_CASE_POSITION